import {Component, Prop, Vue} from "annotation";
import {countPagination} from "../../../../util/Underscore";

@Component
export default class PagingMixin extends Vue {

  @Prop({default: 0})
  public perPage: number;

  @Prop({default: false, type: Boolean})
  public frontEndPagination: boolean;

  @Prop({default: false, type: Boolean})
  public usePaging: boolean;

  @Prop({default: 1})
  public totalData: number;

  public currentPage: number = 1;

  public get maxPage() {
    if (!this.usePaging || this.perPage <= 0 || this.totalData <= 0) {
      return 1;
    }
    return Math.ceil(this.totalData / this.perPage);
  };

  public get paginations() {
    const {usePaging, currentPage, maxPage} = this;

    if (usePaging) {
      return countPagination(currentPage, maxPage);
    }

    return [];
  }

  public onChangePage({value, isDisable}: any) {
    if (!isDisable && value) {
      this.currentPage = value;

      //pages start at 0
      this.$emit('changePage', (value - 1))
    }
  }
}
